import Employees from "../components/Manning/Employees";
import Employee from "../components/Manning/Employee";
export default [
    {path:"/Employees", component: Employees},
    {path:"/NewEmployee", component: Employee},
]